import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['listGroup', 'selectAllCheckbox', 'itemCheckbox', 'totalCountLabel', 'includeAllPagesFlag'];

  toggleAll(){
    if (this.selectAllCheckboxTarget.checked) {
      this.selectAllPages();
    } else {
      this.unselectAllPages();
    }
  }

  selectAll() {
    this.itemCheckboxTargets.forEach(function(target) {
      target.checked = true;
      target.closest('.list-group-item')?.classList?.toggle('is--selected', true);
      target.closest('.item-to-select')?.classList?.toggle('is--selected', true);
    });

    this.itemToggled();
  }

  selectAllPages() {
    this.selectAll();
    this.toggleAllPages(true);
  }

  unselectAll() {
    this.itemCheckboxTargets.forEach(function(target) {
      target.checked = false;
      target.closest('.list-group-item')?.classList?.toggle('is--selected', false);
      target.closest('.item-to-select')?.classList?.toggle('is--selected', true);
    });

    this.itemToggled();
  }

  unselectAllPages() {
    this.toggleAllPages(false);
    this.unselectAll();
  }

  toggleAllPages(status) {
    if (this.hasIncludeAllPagesFlagTarget) {
      this.includeAllPagesFlagTarget.value = status;
      this.updateTotalCountLabel(this.getSelectedCount(), status);
      this.updateTargetCheckboxes();
    } else if (this.context.element.dataset.updateTargetCheckbox) {
      this.updateTotalCountLabel(this.getSelectedCount(), status);
      this.updateTargetCheckboxes();
      if(status) {
        document.querySelectorAll(this.context.element.dataset.updateTargetCheckbox).forEach(function(checkbox) {
          checkbox.value = 'all';
        });
      }
    }
  }

  itemToggled() {
    if (this.hasIncludeAllPagesFlagTarget) this.includeAllPagesFlagTarget.value = false;

    const selectedCount = this.getSelectedCount();
    const isPageSelected = selectedCount === this.itemCheckboxTargets.length;

    this.selectAllCheckboxTarget.checked = isPageSelected;
    this.updateListGroupClass(selectedCount);
    this.updateTotalCountLabel(selectedCount, false);
    this.updateTargetCheckboxes();
  }

  getSelectedCount() {
    return this.itemCheckboxTargets.filter(target => target.checked).length;
  }

  updateListGroupClass(selectedCount) {
    this.context.element.classList.toggle('is--bulk', selectedCount > 0);
  }

  getTotalCount() {
    const filteredCountEl = this.context.element.querySelector('[data-filtered-total-count]');
    if (filteredCountEl) {
      return filteredCountEl.dataset.filteredTotalCount;
    }
    return this.context.element.dataset.totalCount;
  }

  updateTotalCountLabel(selectedCount, isAllPagesSelected) {
    if (isAllPagesSelected) {
      this.totalCountLabelTarget.innerHTML = `${this.getTotalCount()} selected`;
    } else {
      this.totalCountLabelTarget.innerHTML = `${selectedCount} selected`;
    }
  }

  updateTargetCheckboxes() {
    if (!this.context.element.dataset.updateTargetCheckbox) return;

    const ids = this.itemCheckboxTargets.filter(target => target.checked).map(item => item.value).join(',');
    document.querySelectorAll(this.context.element.dataset.updateTargetCheckbox).forEach(function(checkbox) {
      checkbox.value = ids;
    });
  }
}
